export default {
  add_items: 'Artikel hinzufügen',
  remove_items: 'Artikel entfernen',
  place_order: 'Bestellung aufgeben',
  pay_now: 'Jetzt bezahlen',

  terms:
    'Mit Ihrer Bestellung erklären Sie sich mit unseren <TermsLink>Allgemeinen Geschäftsbedingungen</TermsLink> und unserer <PrivacyPolicyLink>Datenschutzerklärung</PrivacyPolicyLink> einverstanden.',

  error_messages: {
    payment_unsuccessful: {
      title: 'Zahlung fehlgeschlagen',
      description: 'Bitte überprüfe deine Zahlungsinformationen und versuchen es erneut.',
    },
  },
};
